import { render } from "./VeterinarianList.vue?vue&type=template&id=b1286cba"
import script from "./VeterinarianList.vue?vue&type=script&lang=js"
export * from "./VeterinarianList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__